import { TX_GRID_SORT_DISABLED, TX_GRID_SORT_ENABLED, TX_GRID_SORT_REJECTED } from '../actions/tx_grid_sort'

export function txGridSort(state = { sortField: null, order: null, rejection: null }, action) {
  switch (action.type) {
    case TX_GRID_SORT_ENABLED:
      return { ...state, sortField: action.sortField, order: action.order, rejection: null }
    case TX_GRID_SORT_DISABLED:
      return { ...state, sortField: null, order: null, rejection: null }
    case TX_GRID_SORT_REJECTED:
      return { ...state, sortField: null, order: null, rejection: action.message }
    default:
      return state
  }
}
